module.exports = __webpack_public_path__ + "static/media/eileen-avatar.7b99b98b.svg";